import Cookie from "js-cookie";
import { RISKIFIED_SESSION_ID_COOKIE } from "@swo/shared";
import { useEffect } from "react";

export const useRiskifiedIntegration = (config: { storeDomain: string }, currentPath: string, disabled: boolean) => {
  const id = "riskified-session-id-script";
  const STORE_DOMAIN = config.storeDomain;

  function riskifiedBeaconLoad() {
    const session_id = Cookie.get(RISKIFIED_SESSION_ID_COOKIE);

    if (!session_id) {
      return;
    }

    const url =
      ("https:" == document.location.protocol ? "https://" : "http://") +
      `beacon.riskified.com?shop=${STORE_DOMAIN}&sid=${session_id}`;

    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.defer = true;
    s.src = url;
    s.id = id;

    document.body.appendChild(s);
  }

  useEffect(() => {
    if (disabled) {
      return;
    }

    window.setTimeout(() => {
      riskifiedBeaconLoad();
    }, 0);

    return () => {
      const el = document.getElementById(id);

      if (el) {
        el.remove();
      }
    };
  }, [disabled]);

  useEffect(() => {
    if (disabled) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
    const RISKX = (window as any)?.RISKX;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (RISKX && typeof RISKX.go === "function") {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      RISKX.go(currentPath);
    }
  }, [disabled, currentPath]);
};
